<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div
            class="flex  justify-content-space-between align-items marginBottom20"
          >
            <div class="flex align-items">
              <div class="flex align-items marginRight10 marginBottom10">
                <span class="span marginRight10"></span>
                <div class="width250">
                  <el-input
                    v-model="searchData.keyword"
                    placeholder="输入姓名/手机号"
                    @keyup.enter.native="handleSearch"
                    clearable
                    maxlength="20"
                  ></el-input>
                </div>
              </div>

              <div class="flex align-items marginRight10 marginBottom10">
                <el-button
                  size="medium"
                  type="primary"
                  icon="el-icon-search"
                  @click="handleSearch"
                  >查询</el-button
                >
              </div>

              <div class="flex align-items marginRight10 marginBottom10">
                <el-button
                  size="medium"
                  type="info"
                  icon="el-icon-refresh-right"
                  @click="handleReset"
                  >重置</el-button
                >
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd"
              >新增公司</el-button
            >
          </div>
        </div>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <div>
          <el-button type="text" @click="goToMobileWhite(row)"
            >手机号白名单</el-button
          >
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button
            type="text"
            @click="handleStatus(row)"
            v-show="row.status === 0"
            >禁用</el-button
          >
          <el-button
            type="text"
            @click="handleStatus(row)"
            v-show="row.status !== 0"
            >启用</el-button
          >
        </div>
      </template>
    </avue-crud>

    <el-dialog
      v-if="dialogVisible"
      :title="`${form.id ? '编辑公司' : '新增公司'}`"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleModalClose"
    >
      <avue-form
        ref="form"
        v-model="form"
        :option="formOption"
        @submit="submit"
      >
        <template slot="name">
          <el-input
            maxlength="20"
            show-word-limit
            v-model="form.name"
            placeholder="请输入"
            type="text"
            clearable
          />
        </template>

        <template slot="account">
          <el-input
            maxlength="30"
            show-word-limit
            v-model="form.account"
            placeholder="请输入"
            type="text"
            clearable
          />
        </template>

        <template slot="roleId">
          <el-select
            v-model="form.roleId"
            filterable
            placeholder="请选择"
            @change="handleRoleChange"
          >
            <el-option
              v-for="item in infoRoles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <template slot="roleName">
          <el-input
            v-model="form.roleName"
            placeholder="请输入"
            type="text"
            clearable
          />
        </template>
        <template slot="menuForm">
          <el-button icon="el-icon-close" @click="handleClose">取消</el-button>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCompany,
  getInfoRoles,
  addCompany,
  editCompany,
  changeCompanyStatus
} from '@/api/statistics/index'

export default {
  name: 'index',
  data() {
    return {
      searchData: {},
      infoRoles: [],
      page: {
        total: 0,
        currentPage: 1
      },
      tableData: [],
      showLoading: false,
      option: {
        title: '分账公司管理',
        titleSize: 'h3',
        card: true,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: '序号', // 索引文字
        size: 'small',
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: 'center',
        menuAlign: 'center',
        menuType: 'text',
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '公司名称',
            prop: 'name'
          },
          {
            label: '商户号',
            prop: 'account'
          },
          {
            label: '分账关系',
            prop: 'roleName'
          },

          {
            label: '创建时间',
            prop: 'createTime'
          },
          {
            label: '状态',
            prop: 'status',
            formatter: function(row, column, cellValue) {
              return row.status === 0 ? '正常' : '禁用'
            }
          }
        ]
      },
      /**查看modal框 */
      dialogVisible: false,
      form: {
        id: '',
        account: '',
        roleId: '',
        name: '',
        roleName: ''
      },
      formOption: {
        submitText: '确定',
        emptyBtn: false,
        labelWidth: '140',
        column:  [
        {
          label: '公司名称',
          prop: 'name',
          type: 'text',
          maxlength: 20,
          showWordLimit: true,
          span: 24,
          rules: [
            {
              required: true,
              message: '请输入姓名',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '商户号',
          prop: 'account',
          type: 'number',
          span: 24,
          rules: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '分账关系',
          prop: 'roleId',
          type: 'number',
          span: 24,
          rules: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur'
            }
          ]
        }
      ]
      }
    }
  },
  created() {
    this.getInfoRolesData()
  },
  methods: {
    /**新增员工 */
    handleAdd() {
      this.dialogVisible = true
      this.resetForm()
      this.handleResetFormColumn()
    },
    // 编辑
    async handleEdit(row) {
      // console.log('添加')
      const { id, name, roleId, account, roleType } = row

      this.form = {
        id: id,
        account,
        name,
        roleId
      }
      if (roleType === 0) {
        await this.getInfoRolesData()
      }
      this.handleResetFormColumn()
      this.dialogVisible = true
    },
    /**禁用启用 */
    handleStatus(row) {
      const state = row.status == 0 ? '禁用' : '启用'
      this.$confirm(`确定${state}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeCompanyStatus({
          id: row.id,
          status: row.status == 1 ? 0 : 1
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success(`${state}成功!`)
            this.onLoad()
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    onLoad() {
      this.showLoading = true
      getCompany({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchData
      }).then((res) => {
        this.showLoading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.total = res.data.total
        }
      })
    },
    // 添加
    handleView() {
      this.dialogVisible = true
    },
    // 查询
    handleSearch() {
      this.page.currentPage = 1
      this.onLoad()
    },
    // 重置
    handleReset() {
      this.searchData = {
        type: ''
      }
      this.page.currentPage = 1
      this.onLoad()
    },
    /**查看关闭modal框 */
    handleModalClose() {
      this.dialogVisible = false
    },

    handleClose() {
      this.dialogVisible = false
    },
    async submit(form, done) {
      let result
      try {
        if (form.id) {
          // editUser
          result = await editCompany({ ...this.form })
        } else {
          result = await addCompany({ ...this.form })
        }

        if (result.code === 200) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.onLoad()
        } else {
          this.$message.error(result.msg)
        }

        done()
      } catch (error) {
        done()
      }
    },
    /**白名单 */
    goToMobileWhite(row) {
      this.$router.push({
        path: '/statistics/companyManagement/mobileWhite',
        query: {
          companyId: row.id
        }
      })
    },
    /**分账关系-下拉类别 */
    async getInfoRolesData() {
      const data = await getInfoRoles({})
      this.infoRoles = data.data.map((item) => {
        return { value: item.id, label: item.name, code: item.code }
      })
    },
    handleRoleChange(value) {
      const curItem = this.infoRoles.find((item) => item.value === value)
      if (curItem && curItem.code === 'CUSTOM') {
        this.form.roleCode = 'CUSTOM'
        this.formOption.column.push({
          label: '',
          prop: 'roleName',
          type: 'text',
          span: 24,
          rules: [
            {
              required: true,
              message: '请输入',
              trigger: 'blur'
            }
          ]
        })
      } else {
        this.form.roleCode = ''
        if (this.formOption.column.length >= 4) {
          this.formOption.column.pop()
        }
      }
    },
    handleResetFormColumn() {
      this.formOption.column = [
        {
          label: '公司名称',
          prop: 'name',
          type: 'text',
          maxlength: 20,
          showWordLimit: true,
          span: 24,
          rules: [
            {
              required: true,
              message: '请输入公司名称',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '商户号',
          prop: 'account',
          type: 'number',
          span: 24,
          rules: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '分账关系',
          prop: 'roleId',
          type: 'number',
          span: 24,
          rules: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur'
            }
          ]
        }
      ]
    },
    resetForm() {
      this.form = {
        id: '',
        account: '',
        roleId: '',
        name: '',
        roleName: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
